import {IWineShop} from 'modules/wineshops-list/models';
import {useMemo} from 'react';
import {isBySimple} from 'modules/wineshops-list/helpers';

export const useBySimple = (wineshop?: IWineShop) => {
    return useMemo(() => wineshop?.stockTypes?.some((stockType) => isBySimple(stockType.code)), [wineshop]);
};
